// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49","tertiary":"Button_tertiary__kksjv"};